import type { TransactionAsset, TransactionLogDetail } from './mockTransactionLog';

const isMaintenanceTransactionType = (
  transactionType: TransactionLogDetail['transactionType'],
): boolean => {
  return transactionType === 'MAINTENANCE_SEND' || transactionType === 'MAINTENANCE_RECEIVE';
};

export const aggregateMaintenanceAssets = (assets: TransactionAsset[]): TransactionAsset[] => {
  const grouped = new Map<string, TransactionAsset>();

  for (const asset of assets) {
    const key = [asset.lin, asset.nsn, asset.nomenclature].join('|');
    const existing = grouped.get(key);

    if (!existing) {
      grouped.set(key, { ...asset });
      continue;
    }

    existing.transQty += asset.transQty;
  }

  return Array.from(grouped.values());
};

export const resolveDisplayAssetsForTransaction = (
  assets: TransactionAsset[],
  transactionType: TransactionLogDetail['transactionType'],
): TransactionAsset[] => {
  if (!isMaintenanceTransactionType(transactionType)) {
    return assets;
  }
  return aggregateMaintenanceAssets(assets);
};
